var map = {
	"./bash": 1498,
	"./java": 1499,
	"./json": 1500,
	"./julia": 1501,
	"./python": 1502,
	"./r": 1503,
	"./rust": 1504,
	"./scala": 1505,
	"./shell": 1506,
	"./sql": 1507,
	"./xml": 1508,
	"./yaml": 1509
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1497;